export function createRoute(id, routeConfig) {
    return Object.assign({ id: Symbol(id) }, routeConfig);
}
